import { Link } from "react-router-dom";
import { Trophy, ChevronRight } from "lucide-react";

export const EventCTA = ({ eventName }) => (
  <div data-testid="event-cta" className="mt-10 border border-lime-400/40 bg-lime-400/5 p-6 flex flex-wrap items-center gap-4">
    <Trophy className="w-8 h-8 text-lime-400 shrink-0" />
    <div className="flex-1 min-w-[240px]">
      <div className="font-display font-black uppercase text-xl leading-none">Want in on the next one?</div>
      <p className="text-sm text-zinc-400 mt-1.5">
        {eventName ? `${eventName} runs on Pickle Bullpen — the` : "The"} performance ecosystem where players get live brackets, PSI skill ratings, AI coaching and national PBR rankings from every event they play.
      </p>
    </div>
    <div className="flex flex-wrap gap-3">
      <Link to="/events" data-testid="cta-view-events"
        className="border border-lime-400 text-lime-400 hover:bg-lime-400 hover:text-black px-5 py-2.5 text-[10px] font-black uppercase tracking-widest transition-colors">
        Upcoming Tournaments
      </Link>
      <Link to="/auth" data-testid="cta-join-free"
        className="flex items-center gap-1.5 bg-lime-400 text-black hover:bg-lime-300 px-5 py-2.5 text-[10px] font-black uppercase tracking-widest transition-colors">
        Join Free <ChevronRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  </div>
);
